<template>
  <div class="swiper pageKV">
    <div id="mypageKV">

    </div>
    <div class="shoushi" id="shoushi">
      <div class="sbox">
        <div class="sboxinner">
          <div class="pointer" id="pointer">
          </div>
        </div>
      </div>
    </div>

    <!--分享 BEGIN-->
    <div class="sharetip">
      <div class="stip1"></div>
      <div class="stip2"></div>
    </div>
    <!--分享 END-->
  </div>
</template>

<script>
import * as PIXI from 'pixi.js';
import $ from "jquery";

export default {
  props:['carsubtype'],
  data(){
    return{
      appkv:null, //主舞台

      stage1:null,
      stage1bg:require('./s1bg.jpg'),
      s1to1:require('./s1-1.png'),
      s1to2:require('./s1-2.png'),
      s1to3:require('./s1-3.png'),
      s1to4:require('./s1-4.png'),
      s1to5:require('./s1-5.png'),
      s1to6:require('./s1-6.png'),
      s1to7:require('./s1-7.png'),
      s1to8:require('./s1-8.png'),
      s1to9:require('./s1-9.png'),
      s1s0:require('./s1-10.png'),
      s1s1:require('./s1-11.png'),
      moon:null, //月亮
      s1txt1:null, //文字
      s1txt2:null, //文字
      s1txt3:null, //文字
      s1txt4:null, //文字
      s1txt5:null, //文字
      stage1jh:null,
      s1jh0:null, //交互滑块底
      s1jh1:null, //交互滑块球
      stage1bgSpr:null,
      s1jhtipflag:null,


      sence1:null, //洗漱、刷牙、化妆
      sence1bg:require('./a1-bg2.jpg'),
      sence1bg2:require('./a1-bg.jpg'),
      sence1bg3:require('./a1-bg3.jpg'),
      sence1s1:require('./a1-s1.jpg'),
      sence1s2:require('./a1-s2.jpg'),
      sence1s3:require('./a1-s3.jpg'),
      sence1s4:require('./a1-s4.jpg'),
      sence1s5:require('./a1-s5.jpg'),
      sence1s6:require('./a1-s6.jpg'),
      sence1s7:require('./a1-s7.jpg'),
      sence1s8:require('./a1-s8.jpg'),
      sence1s9:require('./a1-s9.jpg'),
      sence1s10:require('./a1-s10.jpg'),
      sence1s11:require('./a1-s11.jpg'),
      sence1s12:require('./a1-s12.jpg'),
      sence1s13:require('./a1-s13.jpg'),
      sence1s14:require('./a1-s14.jpg'),
      sence1s15:require('./a1-s15.jpg'),
      sence1s16:require('./a1-s16.jpg'),
      sence1s17:require('./a1-s17.jpg'),
      sence1s18:require('./a1-s18.jpg'),
      sence1s19:require('./a1-s19.jpg'),
      sence1s20:require('./a1-s20.jpg'),
      sence1s21:require('./a1-s21.jpg'),
      sence1s22:require('./a1-s22.jpg'),
      sence1s23:require('./a1-s23.jpg'),
      sence1s24:require('./a1-s24.jpg'),
      sence1s25:require('./a1-s25.jpg'),
      sence1s26:require('./a1-s26.jpg'),
      sence1s27:require('./a1-s27.jpg'),
      sence1s28:require('./a1-s28.jpg'),
      sence1s29:require('./a1-s29.jpg'),
      sence1s30:require('./a1-s30.jpg'),
      sence1s31:require('./a1-s31.jpg'),
      sence1s32:require('./a1-s32.jpg'),
      sence1s33:require('./a1-s33.jpg'),
      sence1s34:require('./a1-s34.jpg'),
      sence1s35:require('./a1-s35.jpg'),
      sence1s36:require('./a1-s36.jpg'),
      sence1s37:require('./a1-s37.jpg'),
      sence1s38:require('./a1-s38.jpg'),
      sence1s39:require('./a1-s39.jpg'),
      sence1s40:require('./a1-s39.jpg'),
      sence1s41:require('./a1-s39.jpg'),
      sence1s42:require('./a1-s39.jpg'),
      sence1s43:require('./a1-s39.jpg'),
      sence1s44:require('./a1-s39.jpg'),
      sence1s45:require('./a1-s39.jpg'),
      sence1s46:require('./a1-s39.jpg'),
      sence1s47:require('./a1-s39.jpg'),
      sence1s48:require('./a1-s39.jpg'),
      sence1s49:require('./a1-s39.jpg'),
      sence1s50:require('./a1-s40.jpg'),
      sence1txt1:require('./a1-txt1.png'),
      sence1txt2:require('./a1-txt2.png'),
      sence1txt3:require('./a1-txt3.png'),
      animatedSpr:null,
      sence1t1:null,
      sence1t2:null,
      sence1t3:null,


      sence2:null,
      sence2txt1:require('./a2-txt1.png'),
      sence2txt2:require('./a2-txt2.png'),
      sence2s1:require('./a2-s1.jpg'),
      sence2s2:require('./a2-s2.jpg'),
      sence2s3:require('./a2-s3.jpg'),
      sence2s4:require('./a2-s4.jpg'),
      sence2s5:require('./a2-s5.jpg'),
      sence2s6:require('./a2-s6.jpg'),
      sence2s7:require('./a2-s7.jpg'),
      sence2s8:require('./a2-s8.jpg'),
      sence2s9:require('./a2-s9.jpg'),
      sence2s10:require('./a2-s10.jpg'),
      sence2s11:require('./a2-s11.jpg'),
      sence2s12:require('./a2-s12.jpg'),
      sence2s13:require('./a2-s13.jpg'),
      sence2s14:require('./a2-s14.jpg'),
      sence2s15:require('./a2-s15.jpg'),
      sence2s16:require('./a2-s16.jpg'),
      sence2s17:require('./a2-s17.jpg'),
      sence2s18:require('./a2-s18.jpg'),
      sence2s19:require('./a2-s19.jpg'),
      sence2s20:require('./a2-s20.jpg'),
      sence2s21:require('./a2-s21.jpg'),
      sence2s22:require('./a2-s22.jpg'),
      sence2s23:require('./a2-s23.jpg'),
      sence2s24:require('./a2-s24.jpg'),
      sence2s25:require('./a2-s25.jpg'),
      sence2s26:require('./a2-s26.jpg'),
      sence2s27:require('./a2-s27.jpg'),
      sence2s28:require('./a2-s28.jpg'),
      sence2s29:require('./a2-s29.jpg'),
      sence2s30:require('./a2-s30.jpg'),
      sence2s31:require('./a2-s31.jpg'),
      sence2s32:require('./a2-s32.jpg'),
      sence2s33:require('./a2-s33.jpg'),
      sence2s34:require('./a2-s34.jpg'),
      sence2s35:require('./a2-s35.jpg'),
      sence2s36:require('./a2-s36.jpg'),
      sence2s37:require('./a2-s37.jpg'),
      sence2s38:require('./a2-s38.jpg'),
      sence2s39:require('./a2-s39.jpg'),
      sence2s40:require('./a2-s40.jpg'),
      sence2s41:require('./a2-s41.jpg'),
      sence2s42:require('./a2-s42.jpg'),
      sence2s43:require('./a2-s43.jpg'),
      sence2s44:require('./a2-s44.jpg'),
      sence2s45:require('./a2-s45.jpg'),
      sence2s46:require('./a2-s46.jpg'),
      sence2s47:require('./a2-s47.jpg'),
      sence2s48:require('./a2-s48.jpg'),
      sence2s49:require('./a2-s49.jpg'),
      sence2s50:require('./a2-s50.jpg'),
      sence2s51:require('./a2-s51.jpg'),
      sence2s52:require('./a2-s52.jpg'),
      sence2s53:require('./a2-s53.jpg'),
      sence2s54:require('./a2-s54.jpg'),
      sence2s55:require('./a2-s55.jpg'),
      sence2s56:require('./a2-s56.jpg'),
      sence2s57:require('./a2-s57.jpg'),
      sence2s58:require('./a2-s58.jpg'),
      sence2s59:require('./a2-s59.jpg'),
      sence2s60:require('./a2-s60.jpg'),
      sence2s61:require('./a2-s61.jpg'),
      sence2s62:require('./a2-s62.jpg'),
      sence2s63:require('./a2-s63.jpg'),
      sence2s64:require('./a2-s64.jpg'),
      sence2s65:require('./a2-s65.jpg'),
      sence2s66:require('./a2-s66.jpg'),
      sence2s67:require('./a2-s67.jpg'),
      sence2s68:require('./a2-s68.jpg'),
      sence2s69:require('./a2-s69.jpg'),
      sence2s70:require('./a2-s70.jpg'),
      sence2s71:require('./a2-s71.jpg'),
      sence2s72:require('./a2-s72.jpg'),
      sence2t1:null,
      sence2t2:null,
      animatedSubway:null,


      sence3:null,
      sence3s1:require('./a3-s1.jpg'),
      sence3s2:require('./a3-s2.jpg'),
      sence3s3:require('./a3-s3.jpg'),
      sence3s4:require('./a3-s4.jpg'),
      sence3s5:require('./a3-s5.jpg'),
      sence3s6:require('./a3-s6.jpg'),
      sence3s7:require('./a3-s7.jpg'),
      sence3s8:require('./a3-s8.jpg'),
      sence3s9:require('./a3-s9.jpg'),
      sence3s10:require('./a3-s10.jpg'),
      sence3s11:require('./a3-s11.jpg'),
      sence3s12:require('./a3-s12.jpg'),
      sence3s13:require('./a3-s13.jpg'),
      sence3s14:require('./a3-s14.jpg'),
      sence3s15:require('./a3-s15.jpg'),
      sence3s16:require('./a3-s16.jpg'),
      sence3s17:require('./a3-s17.jpg'),
      sence3s18:require('./a3-s18.jpg'),
      sence3s19:require('./a3-s19.jpg'),
      sence3s20:require('./a3-s20.jpg'),
      sence3s21:require('./a3-s21.jpg'),
      sence3s22:require('./a3-s22.jpg'),
      sence3s23:require('./a3-s23.jpg'),
      sence3s24:require('./a3-s24.jpg'),
      sence3s25:require('./a3-s25.jpg'),
      sence3s26:require('./a3-s26.jpg'),
      sence3s27:require('./a3-s27.jpg'),
      sence3s28:require('./a3-s28.jpg'),
      sence3s29:require('./a3-s29.jpg'),
      sence3s30:require('./a3-s30.jpg'),
      sence3s31:require('./a3-s31.jpg'),
      sence3s32:require('./a3-s32.jpg'),
      sence3s33:require('./a3-s33.jpg'),
      sence3s34:require('./a3-s34.jpg'),
      sence3s35:require('./a3-s35.jpg'),
      sence3s36:require('./a3-s36.jpg'),
      sence3s37:require('./a3-s37.jpg'),
      sence3s38:require('./a3-s38.jpg'),
      sence3s39:require('./a3-s39.jpg'),
      sence3s40:require('./a3-s40.jpg'),
      sence3s41:require('./a3-s41.jpg'),
      sence3s42:require('./a3-s42.jpg'),
      sence3s43:require('./a3-s43.jpg'),
      sence3s44:require('./a3-s44.jpg'),
      sence3s45:require('./a3-s45.jpg'),
      sence3s46:require('./a3-s46.jpg'),
      sence3s47:require('./a3-s47.jpg'),
      sence3s48:require('./a3-s48.jpg'),
      sence3s49:require('./a3-s49.jpg'),
      sence3s50:require('./a3-s50.jpg'),
      sence3s51:require('./a3-s51.jpg'),
      sence3s52:require('./a3-s52.jpg'),
      sence3s53:require('./a3-s53.jpg'),
      sence3s54:require('./a3-s54.jpg'),
      sence3s55:require('./a3-s55.jpg'),
      sence3s56:require('./a3-s56.jpg'),
      sence3s57:require('./a3-s57.jpg'),
      sence3s58:require('./a3-s58.jpg'),
      sence3s59:require('./a3-s59.jpg'),
      sence3s60:require('./a3-s60.jpg'),
      sence3s61:require('./a3-s61.jpg'),
      sence3s62:require('./a3-s62.jpg'),
      sence3s63:require('./a3-s63.jpg'),
      sence3s64:require('./a3-s64.jpg'),
      sence3s65:require('./a3-s65.jpg'),
      sence3s66:require('./a3-s66.jpg'),
      sence3s67:require('./a3-s67.jpg'),
      sence3s68:require('./a3-s68.jpg'),
      sence3s69:require('./a3-s69.jpg'),
      sence3s70:require('./a3-s70.jpg'),
      sence3s71:require('./a3-s71.jpg'),
      sence3s72:require('./a3-s72.jpg'),
      sence3s73:require('./a3-s73.jpg'),
      sence3s74:require('./a3-s74.jpg'),
      sence3s75:require('./a3-s75.jpg'),
      sence3s76:require('./a3-s76.jpg'),
      sence3s77:require('./a3-s77.jpg'),
      sence3s78:require('./a3-s78.jpg'),
      sence3s79:require('./a3-s79.jpg'),
      sence3s80:require('./a3-s80.jpg'),
      sence3s81:require('./a3-s81.jpg'),
      sence3s82:require('./a3-s82.jpg'),
      sence3s83:require('./a3-s83.jpg'),
      sence3s84:require('./a3-s84.jpg'),
      sence3s85:require('./a3-s85.jpg'),
      sence3txt1:require('./a3-txt1.png'),
      sence3txt2:require('./a3-txt2.png'),
      sence4txt1:require('./a4-txt1.png'),
      sence4txt2:require('./a4-txt2.png'),
      animatedOffice:null,
      animatedOffice2:null,
      animatedOfficew1:null,
      sence3t1:null,
      sence3t2:null,
      sence4t1:null,
      sence4t2:null,

      sence4:null,


      sence5:null,
      sence5bg2:require('./a5-bg2.jpg'),
      sence5bg3:require('./a5-bg3.jpg'),
      sence5s1:require('./a5-s1.jpg'),
      sence5s2:require('./a5-s2.jpg'),
      sence5s3:require('./a5-s3.jpg'),
      sence5s4:require('./a5-s4.jpg'),
      sence5s5:require('./a5-s5.jpg'),
      sence5s6:require('./a5-s6.jpg'),
      sence5s7:require('./a5-s7.jpg'),
      sence5s8:require('./a5-s8.jpg'),
      sence5s9:require('./a5-s9.jpg'),
      sence5s10:require('./a5-s10.jpg'),
      sence5s11:require('./a5-s11.jpg'),
      sence5s12:require('./a5-s12.jpg'),
      sence5s13:require('./a5-s13.jpg'),
      sence5s14:require('./a5-s14.jpg'),
      sence5s15:require('./a5-s15.jpg'),
      sence5s16:require('./a5-s16.jpg'),
      sence5s17:require('./a5-s17.jpg'),
      sence5s18:require('./a5-s18.jpg'),
      sence5s19:require('./a5-s19.jpg'),
      sence5s20:require('./a5-s20.jpg'),
      sence5s21:require('./a5-s21.jpg'),
      sence5s22:require('./a5-s22.jpg'),
      sence5s23:require('./a5-s23.jpg'),
      sence5s24:require('./a5-s24.jpg'),
      sence5s25:require('./a5-s25.jpg'),
      sence5s26:require('./a5-s26.jpg'),
      sence5s27:require('./a5-s27.jpg'),
      sence5s28:require('./a5-s28.jpg'),
      sence5s29:require('./a5-s29.jpg'),
      sence5s30:require('./a5-s30.jpg'),
      sence5txt1:require('./a5-txt1.png'),
      sence5txt2:require('./a5-txt2.png'),
      sence5txt3:require('./a5-txt3.png'),
      handtip:require('./hand.png'),
      animatedhome:null,
      sence5t1:null,
      sence5t2:null,
      sence5t3:null,

      sence6:null,
      sence6bg:require('./a6-bg.jpg'),
      sence6s1:require('./a6-1.png'),
      sence6s2:require('./a6-2.png'),
      sence6s3:require('./a6-3.png'),
      sence6s4:require('./a6-4.png'),
      sence6s5:require('./a6-5.png'),
      sence6s6:require('./a6-6.png'),
      sence6s7:require('./a6-7.png'),
      sence6s8:require('./a6-8.png'),
      sence6txt1:require('./a6-txt1.png'),
      sence6txt2:require('./a6-txt2.png'),
      sence6txt3:require('./a6-txt3.png'),
      sence6hand:null,
      sence6mailer:null,
      sence6t1:null,
      sence6t2:null,
      sence6t3:null,


      result:null,
      resultbg:require('./result-bg.jpg'),
      resultbg2:require('./result-bg.png'),
      resultbtn1:require('./result-btn1.png'),
      resultbtn2:require('./result-btn2.png'),
      resultlogo:require('./result-logo.jpg'),
      results1:require('./result-1.png'),
      results2:require('./result-2.png'),
      results3:require('./result-3.png'),
      resulty1:require('./result-y1.png'),
      resulty2:require('./result-y2.png'),
      resulty3:require('./result-y3.png'),
      resulty4:require('./result-y4.png'),
      resulty5:require('./result-y5.png'),
      resulty6:require('./result-y6.png'),
      resulty7:require('./result-y7.png'),
      resulty8:require('./result-y8.png'),
      resultstars:require('./result-stars.png'),
      resultmoon:require('./result-moon.png'),
      resultmoon2:require('./result-moon2.png'),
      resulttxt1:require('./result-txt2.png'),
      resulttxt2:require('./result-txt1.png'),
      resulttxtCont:null,

      scalexs:0.8,
    }
  },
  mounted(){
    this.init()
    

  },
  methods:{
    init(){
      let _this=this

      this.appkv=new PIXI.Application({width:750,height:1380});
      document.getElementById('mypageKV').appendChild(this.appkv.view);

      this.resultstage()


      /******* 内容6：手机界面 BEGIN *******/
      this.sence6Stage()
      /******* 内容6：手机界面 END *******/



      /******* 内容5：卧室场景 BEGIN *******/
      this.sence5Stage()
      /******* 内容5：卧室场景 END *******/
    


      /******* 内容4：晚餐，办公室内吃简餐 BEGIN *******/
      this.sence4Stage()
      /******* 内容4：晚餐，办公室内吃简餐 END *******/



      /******* 内容3：办公场景 BEGIN *******/
      this.sence3Stage()
      /******* 内容3：办公场景 END *******/



      /******* 内容2：早高峰通勤上班 BEGIN *******/
      this.sence2Stage()
      /******* 内容2：早高峰通勤上班 END *******/



      /******* 内容1：起床洗漱妆容 BEGIN *******/
      this.sence1Stage()    
      /******* 内容1：起床洗漱妆容 END *******/



      /******* 主舞台 BEGIN *******/
      this.mainkv()
      /******* 主舞台 END *******/
    },
    mainkv(){
      //主舞台 布局
      let _this=this

      this.stage1=new PIXI.Container()
      this.appkv.stage.addChild(this.stage1)


      //设置kv大背景
      let s1bg=PIXI.Texture.fromImage(this.stage1bg)
      this.stage1bgSpr=new PIXI.Sprite(s1bg)

      this.stage1bgSpr.x=0
      this.stage1bgSpr.y=0
      this.stage1bgSpr.width=750
      this.stage1bgSpr.height=1380

      this.stage1.addChild(this.stage1bgSpr)

      //月亮
      let s1to4org=PIXI.Texture.fromImage(this.s1to4)
      this.moon=new PIXI.Sprite(s1to4org)

      this.moon.x=750
      this.moon.y=160
      this.moon.width=202
      this.moon.height=180

      this.stage1.addChild(this.moon)

      //窗户窗帘
      let s1to3org=PIXI.Texture.fromImage(this.s1to3)
      let s1to3=new PIXI.Sprite(s1to3org)

      s1to3.x=0
      s1to3.y=0
      s1to3.width=750
      s1to3.height=1380

      this.stage1.addChild(s1to3)

      //闪动的灯光
      let s1to1org=PIXI.Texture.fromImage(this.s1to1)
      let s1to1=new PIXI.Sprite(s1to1org)

      s1to1.x=0
      s1to1.y=163
      s1to1.width=351
      s1to1.height=574

      this.stage1.addChild(s1to1)

      //闪动的灯光
      s1to1.alpha=0
      TweenMax.to(s1to1,5,{alpha:1,ease:Sine.easeOut,repeat:-1,delay:2})

      //人物以及其他元素
      let s1to2org=PIXI.Texture.fromImage(this.s1to2)
      let s1to2=new PIXI.Sprite(s1to2org)

      s1to2.x=0
      s1to2.y=0
      s1to2.width=750
      s1to2.height=1380

      this.stage1.addChild(s1to2)


      //文字部分
      /*let s1to5org=PIXI.Texture.fromImage(this.s1to5)
      this.s1txt1=new PIXI.Sprite(s1to5org)
      this.s1txt1.x=84
      this.s1txt1.y=107
      this.s1txt1.width=260
      this.s1txt1.height=87
      this.s1txt1.alpha=0
      this.stage1.addChild(this.s1txt1)

      let s1to6org=PIXI.Texture.fromImage(this.s1to6)
      this.s1txt2=new PIXI.Sprite(s1to6org)
      this.s1txt2.x=201
      this.s1txt2.y=205
      this.s1txt2.width=453
      this.s1txt2.height=139
      this.s1txt2.alpha=0
      this.stage1.addChild(this.s1txt2)
      */

      let txtCont=new PIXI.Container()
      txtCont.x=47
      txtCont.y=138
      this.stage1.addChild(txtCont)

      let s1to7org=PIXI.Texture.fromImage(this.s1to7)
      this.s1txt3=new PIXI.Sprite(s1to7org)
      this.s1txt3.x=0
      this.s1txt3.y=0
      this.s1txt3.width=378
      this.s1txt3.height=44
      this.s1txt3.alpha=0
      txtCont.addChild(this.s1txt3)

      let s1to8org=PIXI.Texture.fromImage(this.s1to8)
      this.s1txt4=new PIXI.Sprite(s1to8org)
      this.s1txt4.x=0
      this.s1txt4.y=44
      this.s1txt4.width=378
      this.s1txt4.height=50
      this.s1txt4.alpha=0
      txtCont.addChild(this.s1txt4)

      let s1to9org=PIXI.Texture.fromImage(this.s1to9)
      this.s1txt5=new PIXI.Sprite(s1to9org)
      this.s1txt5.x=0
      this.s1txt5.y=94
      this.s1txt5.width=378
      this.s1txt5.height=44
      this.s1txt5.alpha=0
      txtCont.addChild(this.s1txt5)

      //滑动手势
      /*this.stage1jh=new PIXI.Container()
      this.stage1jh.x=167
      this.stage1jh.y=1084
      this.stage1jh.width=441
      this.stage1jh.height=63
      this.stage1jh.alpha=0
      this.stage1.addChild(this.stage1jh)


      let s1to10org=PIXI.Texture.fromImage(this.s1s0)
      this.s1s0=new PIXI.Sprite(s1to10org)
      this.s1s0.x=0
      this.s1s0.y=0
      this.s1s0.width=441
      this.s1s0.height=63
      
      this.stage1jh.addChild(this.s1s0)

      let s1to11org=PIXI.Texture.fromImage(this.s1s1)
      this.s1s1=new PIXI.Sprite(s1to11org)
      this.s1s1.x=323
      this.s1s1.y=0
      this.s1s1.width=64
      this.s1s1.height=58
      this.stage1jh.addChild(this.s1s1)


      
      */
      
    },
    huaaction(){
      let _this=this
      //翻页
      let s1startpos=0
      let initobj=0
      
      document.getElementById('shoushi').ontouchstart=function(){
        s1startpos=event.targetTouches[0].pageX;
        
        //initobj=_this.s1s1.x
        initobj=270/2  
        $('.pointer').removeClass('paction') 
        document.getElementById('pointer').style.left=initobj+'px'
      }

      document.getElementById('shoushi').ontouchmove=function(){
        let posx=event.targetTouches[0].pageX;

        let dur=s1startpos-posx

        
        if(dur>2){
          

          let objx=initobj-dur
 
          if(objx<initobj/2){
            document.getElementById('pointer').style.left=0+'px'

            //执行翻页
            _this.fanyue('stage1','sence1StageMotion')
            $('.shoushi').hide()
          }else{
            //_this.s1s1.x=objx
            document.getElementById('pointer').style.left=objx+'px'
          }

        }
      }
    },

    //翻页
    fanyue(stg,fun){
        let _this=this
        let stage=eval('this.'+stg)
        let func=eval('this.'+fun)
        /*TweenMax.to(stage,1,{rotation:1,ease:Sine.easeOut,onComplete:()=>{
          TweenMax.to(stage,1,{y:1334,ease:Sine.easeOut,onComplete:()=>{
            func()
          }})
        }})*/
        TweenMax.to(stage,1,{alpha:0,ease:Sine.easeOut,onComplete:()=>{
          func()
          _this.appkv.stage.removeChild(stage)
        }})

    },

    mainkvMotion(){
      

      //主舞台 动画
      let _this=this
      //启动月亮升起动画
      TweenMax.to(this.moon,6,{x:549,y:39,ease:Sine.easeOut,delay:1})

      //文字出现
      //TweenMax.to(this.s1txt1,2,{alpha:1,ease:Sine.easeOut,delay:1})
      //TweenMax.to(this.s1txt2,2,{alpha:1,ease:Sine.easeOut,delay:2})

      //TweenMax.to(_this.s1txt1,1,{alpha:0,ease:Sine.easeOut,delay:2})
      //TweenMax.to(_this.s1txt2,1,{alpha:0,ease:Sine.easeOut,delay:3})

      TweenMax.to(_this.s1txt3,2,{alpha:1,ease:Sine.easeOut,onStart:()=>{
        //背景口播
        let koubodata={
          name:'001'
        }

        _this.$emit('gokoubo',koubodata) 
      }})
      TweenMax.to(_this.s1txt4,2,{alpha:1,ease:Sine.easeOut,delay:2})
      TweenMax.to(_this.s1txt5,2,{alpha:1,ease:Sine.easeOut,delay:4,onComplete:()=>{
        $('.shoushi').show()
        $('.pointer').addClass('paction')
        _this.huaaction()
      }})



    },


    sence1Stage(){
      let _this=this

      this.sence1=new PIXI.Container()
      this.appkv.stage.addChild(this.sence1)

      //化妆
      let senceCont2=new PIXI.Container()
      this.sence1.addChild(senceCont2)
      
      let sence3bgorg=PIXI.Texture.fromImage(this.sence1bg3)
      let sence1bg3=new PIXI.Sprite(sence3bgorg)

      sence1bg3.x=0
      sence1bg3.y=0
      sence1bg3.width=750
      sence1bg3.height=1380

      senceCont2.addChild(sence1bg3)

      //化妆动画
      let textureArr=[]
      for(let i=13;i<51;i++){
        let t=eval('this.sence1s'+i)
        let texture=PIXI.Texture.fromImage(t)
        textureArr.push(texture)
      }
      this.animatedSpr=new PIXI.extras.AnimatedSprite(textureArr)
      this.animatedSpr.position.x=167
      this.animatedSpr.position.y=248
      this.animatedSpr.animationSpeed = parseFloat((40 / 120).toFixed(2))
      this.animatedSpr.loop=false
      this.animatedSpr.onComplete=()=>{
        //进入下一个场景
        //执行翻页
        _this.fanyue('sence1','sence2StageMotion')
      }
      senceCont2.addChild(this.animatedSpr)

      //刷牙
      let senceCont1=new PIXI.Container()
      this.sence1.addChild(senceCont1)
      
      let sence2bgorg=PIXI.Texture.fromImage(this.sence1bg2)
      let sence1bg2=new PIXI.Sprite(sence2bgorg)

      sence1bg2.x=0
      sence1bg2.y=0
      sence1bg2.width=750
      sence1bg2.height=1380

      senceCont1.addChild(sence1bg2)

      //洗漱
      let senceCont0=new PIXI.Container()
      this.sence1.addChild(senceCont0)

      let sence1bgorg=PIXI.Texture.fromImage(this.sence1bg)
      let sence1bg1=new PIXI.Sprite(sence1bgorg)

      sence1bg1.x=0
      sence1bg1.y=0
      sence1bg1.width=750
      sence1bg1.height=1380

      senceCont0.addChild(sence1bg1)


      //文字
      let senceCont=new PIXI.Container()
      senceCont.x=30
      senceCont.y=1122
      this.sence1.addChild(senceCont)


      let sence1txt1org=PIXI.Texture.fromImage(this.sence1txt1)
      this.sence1t1=new PIXI.Sprite(sence1txt1org)
      this.sence1t1.x=0
      this.sence1t1.y=0
      this.sence1t1.width=386
      this.sence1t1.height=44
      this.sence1t1.alpha=0
      senceCont.addChild(this.sence1t1)


      let sence1txt2org=PIXI.Texture.fromImage(this.sence1txt2)
      this.sence1t2=new PIXI.Sprite(sence1txt2org)
      this.sence1t2.x=0
      this.sence1t2.y=44
      this.sence1t2.width=386
      this.sence1t2.height=52
      this.sence1t2.alpha=0
      senceCont.addChild(this.sence1t2)


      let sence1txt3org=PIXI.Texture.fromImage(this.sence1txt3)
      this.sence1t3=new PIXI.Sprite(sence1txt3org)
      this.sence1t3.x=0
      this.sence1t3.y=96
      this.sence1t3.width=386
      this.sence1t3.height=51
      this.sence1t3.alpha=0
      senceCont.addChild(this.sence1t3)

      
    },


    sence1StageMotion(){
      //背景口播
      let koubodata={
        name:'002'
      }

      this.$emit('gokoubo',koubodata) 

      let _this=this

      let sence1Children=this.sence1.children

      
      
      
      let data={
        name:'shuilongtou'
      }

      _this.$emit('gomymusic',data)

      //洗漱
      TweenMax.to(sence1Children[2],1,{alpha:0,ease:Sine.easeOut,delay:2,onComplete:()=>{
        /*let data2={
          name:'shuaya'
        }

        _this.$emit('gomymusic',data2)*/
        
        //刷牙
        TweenMax.to(sence1Children[1],1,{alpha:0,ease:Sine.easeOut,delay:2,onComplete:()=>{
          _this.$emit('gostopmusic')
          //化妆
          _this.animatedSpr.play()
        }})
      }})

      //文字
      TweenMax.to(_this.sence1t1,2,{alpha:1,ease:Sine.easeOut})
      TweenMax.to(_this.sence1t2,2,{alpha:1,ease:Sine.easeOut,delay:2})
      TweenMax.to(_this.sence1t3,2,{alpha:1,ease:Sine.easeOut,delay:4})
    },


    sence2Stage(){
      let _this=this

      this.sence2=new PIXI.Container()
      this.appkv.stage.addChild(this.sence2)

      let textureArr=[]
      for(let i=1;i<73;i++){
        let t=eval('this.sence2s'+i)
        let texture=PIXI.Texture.fromImage(t)
        textureArr.push(texture)
      }
      this.animatedSubway=new PIXI.extras.AnimatedSprite(textureArr)
      this.animatedSubway.position.x=0
      this.animatedSubway.position.y=0
      this.animatedSubway.animationSpeed = parseFloat((20 / 120).toFixed(2))
      this.animatedSubway.loop=false
      this.animatedSubway.onComplete=()=>{
        //进入下一个场景
        //执行翻页
        _this.fanyue('sence2','sence3StageMotion')
        //_this.fanyue('sence2','sence5StageMotion')
      }
      this.sence2.addChild(this.animatedSubway)

      //文字
      let senceCont=new PIXI.Container()
      senceCont.x=127
      senceCont.y=1130
      this.sence2.addChild(senceCont)


      let sence2txt1org=PIXI.Texture.fromImage(this.sence2txt1)
      this.sence2t1=new PIXI.Sprite(sence2txt1org)
      this.sence2t1.x=0
      this.sence2t1.y=0
      this.sence2t1.width=502
      this.sence2t1.height=56
      this.sence2t1.alpha=0
      senceCont.addChild(this.sence2t1)


      let sence2txt2org=PIXI.Texture.fromImage(this.sence2txt2)
      this.sence2t2=new PIXI.Sprite(sence2txt2org)
      this.sence2t2.x=0
      this.sence2t2.y=56
      this.sence2t2.width=502
      this.sence2t2.height=56
      this.sence2t2.alpha=0
      senceCont.addChild(this.sence2t2)

    },


    sence2StageMotion(){
      //地铁
      //背景口播
      let koubodata={
        name:'003'
      }

      this.$emit('gokoubo',koubodata) 

      //播放地铁声
      let data={
        name:'ditie'
      }

      this.$emit('gomymusic',data)

      let _this=this

     this.animatedSubway.play()
      

      //文字
      TweenMax.to(_this.sence2t1,2,{alpha:1,ease:Sine.easeOut,delay:1})
      TweenMax.to(_this.sence2t2,2,{alpha:1,ease:Sine.easeOut,delay:3})
    },


    sence3Stage(){
      let _this=this
      //办公室
      this.sence3=new PIXI.Container()
      this.appkv.stage.addChild(this.sence3)

      let senceCont0=new PIXI.Container()
      senceCont0.name='bangongshi'
      this.sence3.addChild(senceCont0)

      let textureArr=[]
      for(let i=1;i<49;i++){
        let t=eval('this.sence3s'+i)
        let texture=PIXI.Texture.fromImage(t)
        textureArr.push(texture)
      }
      this.animatedOffice=new PIXI.extras.AnimatedSprite(textureArr)
      this.animatedOffice.position.x=0
      this.animatedOffice.position.y=0
      this.animatedOffice.animationSpeed = parseFloat((12 / 120).toFixed(2))
      this.animatedOffice.loop=false
      this.animatedOffice.onComplete=()=>{
        //进入下一个场景
        //senceCont0.setChildIndex(_this.animatedOffice2,(senceCont0.children.length-1))
        //senceCont0.removeChild(this.animatedOffice)
        TweenMax.to(_this.sence3,0,{alpha:0,ease:Sine.easeOut})
        
        _this.sence4StageMotion()

        TweenMax.to(_this.sence4t1,2,{alpha:1,ease:Sine.easeOut})
        TweenMax.to(_this.sence4t2,2,{alpha:1,ease:Sine.easeOut,delay:2})
      }
      senceCont0.addChild(this.animatedOffice)
      



      //文字
      let senceCont=new PIXI.Container()
      senceCont.x=26
      senceCont.y=198
      this.sence3.addChild(senceCont)


      let sence3txt1org=PIXI.Texture.fromImage(this.sence3txt1)
      this.sence3t1=new PIXI.Sprite(sence3txt1org)
      this.sence3t1.x=0
      this.sence3t1.y=0
      this.sence3t1.width=485
      this.sence3t1.height=44
      this.sence3t1.alpha=0
      senceCont.addChild(this.sence3t1)


      let sence3txt2org=PIXI.Texture.fromImage(this.sence3txt2)
      this.sence3t2=new PIXI.Sprite(sence3txt2org)
      this.sence3t2.x=0
      this.sence3t2.y=44
      this.sence3t2.width=485
      this.sence3t2.height=44
      this.sence3t2.alpha=0
      senceCont.addChild(this.sence3t2)
    },


    sence3StageMotion(){
      this.$emit('gostopmusic')

      //办公室
      //背景口播
      let koubodata={
        name:'004'
      }

      this.$emit('gokoubo',koubodata) 

      let data={
        name:'dazi'
      }

      this.$emit('gomymusic',data)

      let _this=this
      this.animatedOffice.play()

      let donhuala=this.sence3.children[0].children


      //文字
      TweenMax.to(_this.sence3t1,2,{alpha:1,ease:Sine.easeOut})
      TweenMax.to(_this.sence3t2,2,{alpha:1,ease:Sine.easeOut,delay:2})

      
      
    },

    sence4Stage(){
      let _this=this
      //办公室
      this.sence4=new PIXI.Container()
      this.appkv.stage.addChild(this.sence4)

      let senceCont0=new PIXI.Container()
      this.sence4.addChild(senceCont0)

      let textureArr2=[]
      for(let i=49;i<86;i++){
        let t2=eval('this.sence3s'+i)
        let texture2=PIXI.Texture.fromImage(t2)
        textureArr2.push(texture2)
      }
      this.animatedOffice2=new PIXI.extras.AnimatedSprite(textureArr2)
      this.animatedOffice2.position.x=0
      this.animatedOffice2.position.y=0
      this.animatedOffice2.animationSpeed = parseFloat((10 / 120).toFixed(2))
      this.animatedOffice2.loop=false
      this.animatedOffice2.onComplete=()=>{
        //进入下一个场景
        //执行翻页
        _this.fanyue('sence4','sence5StageMotion')
      }
      senceCont0.addChild(this.animatedOffice2)

      //文字
      let senceCont=new PIXI.Container()
      senceCont.x=26
      senceCont.y=198
      this.sence4.addChild(senceCont)

      let sence4txt1org=PIXI.Texture.fromImage(this.sence4txt1)
      this.sence4t1=new PIXI.Sprite(sence4txt1org)
      this.sence4t1.x=35
      this.sence4t1.y=-24
      this.sence4t1.width=524
      this.sence4t1.height=44
      this.sence4t1.alpha=0
      senceCont.addChild(this.sence4t1)


      let sence4txt2org=PIXI.Texture.fromImage(this.sence4txt2)
      this.sence4t2=new PIXI.Sprite(sence4txt2org)
      this.sence4t2.x=35
      this.sence4t2.y=26
      this.sence4t2.width=524
      this.sence4t2.height=44
      this.sence4t2.alpha=0
      senceCont.addChild(this.sence4t2)
    },

    sence4StageMotion(){
      let _this=this

      _this.animatedOffice2.play()

      TweenMax.to(_this.sence3t1,1,{alpha:0,ease:Sine.easeOut})
      TweenMax.to(_this.sence3t2,1,{alpha:0,ease:Sine.easeOut,onComplete:()=>{
        //背景口播
        let koubodata={
          name:'005'
        }

        _this.$emit('gokoubo',koubodata) 

        setTimeout(()=>{
          //播放吃声
          let data={
            name:'chi'
          }

          _this.$emit('gomymusic',data)
        },5000)
      }})
    },

    sence5Stage(){
      this.sence5=new PIXI.Container()
      this.appkv.stage.addChild(this.sence5)

      //3
      let senceCont2=new PIXI.Container()
      this.sence5.addChild(senceCont2)

      let sence5bg3org=PIXI.Texture.fromImage(this.sence5bg3)
      let sence5bg3=new PIXI.Sprite(sence5bg3org)

      sence5bg3.x=0
      sence5bg3.y=0
      sence5bg3.width=750
      sence5bg3.height=1380

      senceCont2.addChild(sence5bg3)


      //2
      let senceCont1=new PIXI.Container()
      this.sence5.addChild(senceCont1)

      let sence5bg2org=PIXI.Texture.fromImage(this.sence5bg2)
      let sence5bg2=new PIXI.Sprite(sence5bg2org)

      sence5bg2.x=0
      sence5bg2.y=0
      sence5bg2.width=750
      sence5bg2.height=1380

      senceCont1.addChild(sence5bg2)

      
      //1
      let senceCont0=new PIXI.Container()
      this.sence5.addChild(senceCont0)

     let textureArr=[]
      for(let i=1;i<31;i++){
        let t=eval('this.sence5s'+i)
        let texture=PIXI.Texture.fromImage(t)
        textureArr.push(texture)
      }
      this.animatedhome=new PIXI.extras.AnimatedSprite(textureArr)
      this.animatedhome.position.x=0
      this.animatedhome.position.y=0
      this.animatedhome.animationSpeed = parseFloat((15 / 120).toFixed(2))
      this.animatedhome.loop=false
      this.animatedhome.onComplete=()=>{
        //进入下一个场景
        let _this=this

        //let sence5Children=_this.sence5.children

        //3
        TweenMax.to(senceCont0,3,{alpha:0,ease:Sine.easeOut,onComplete:()=>{
          //2
          TweenMax.to(senceCont1,3,{alpha:0,ease:Sine.easeOut,onComplete:()=>{
            //执行翻页
            _this.fanyue('sence5','sence6StageMotion')
          }})
        }})
      }
      senceCont0.addChild(this.animatedhome)


      //文字
      let senceCont=new PIXI.Container()
      senceCont.x=29
      senceCont.y=125
      this.sence5.addChild(senceCont)


      let sence5txt1org=PIXI.Texture.fromImage(this.sence5txt1)
      this.sence5t1=new PIXI.Sprite(sence5txt1org)
      this.sence5t1.x=0
      this.sence5t1.y=0
      this.sence5t1.width=523
      this.sence5t1.height=44
      this.sence5t1.alpha=0
      senceCont.addChild(this.sence5t1)


      let sence5txt2org=PIXI.Texture.fromImage(this.sence5txt2)
      this.sence5t2=new PIXI.Sprite(sence5txt2org)
      this.sence5t2.x=0
      this.sence5t2.y=44
      this.sence5t2.width=523
      this.sence5t2.height=52
      this.sence5t2.alpha=0
      senceCont.addChild(this.sence5t2)


      let sence5txt3org=PIXI.Texture.fromImage(this.sence5txt3)
      this.sence5t3=new PIXI.Sprite(sence5txt3org)
      this.sence5t3.x=0
      this.sence5t3.y=96
      this.sence5t3.width=523
      this.sence5t3.height=41
      this.sence5t3.alpha=0
      senceCont.addChild(this.sence5t3)
    },


    sence5StageMotion(){
      //卧室
      //背景口播
      let koubodata={
        name:'006'
      }

      this.$emit('gokoubo',koubodata) 

      this.$emit('gokoubo',koubodata) 

      let data={
        name:'jianpan2'
      }

      this.$emit('gomymusic',data)

      let _this=this

      this.animatedhome.play()

      //文字
      TweenMax.to(_this.sence5t1,2,{alpha:1,ease:Sine.easeOut,delay:1})
      TweenMax.to(_this.sence5t2,2,{alpha:1,ease:Sine.easeOut,delay:3})
      TweenMax.to(_this.sence5t3,2,{alpha:1,ease:Sine.easeOut,delay:5})
    },


    sence6Stage(){
      this.sence6=new PIXI.Container()
      this.appkv.stage.addChild(this.sence6)

      //手持手机
      let sence6bgorg=PIXI.Texture.fromImage(this.sence6bg)
      let sence6bg=new PIXI.Sprite(sence6bgorg)

      sence6bg.x=0
      sence6bg.y=0
      sence6bg.width=750
      sence6bg.height=1380

      this.sence6.addChild(sence6bg)


      //手机屏幕
      let senceCont0=new PIXI.Container()
      this.sence6.addChild(senceCont0)
      senceCont0.rotation=-0.18
      senceCont0.x=65
      senceCont0.y=368

      //手机屏幕添加遮罩
      var e = new PIXI.Graphics();
      e.beginFill(10932373),
      e.drawRect(5, 368, 460, 701),
      e.endFill();
      e.rotation=-0.18
      senceCont0.mask=e


      //2
      let sence6s4org=PIXI.Texture.fromImage(this.sence6s4)
      let sence6p2=new PIXI.Sprite(sence6s4org)

      sence6p2.x=0
      sence6p2.y=0
      sence6p2.width=473
      sence6p2.height=701

      senceCont0.addChild(sence6p2)

      //1
      let sence6s3org=PIXI.Texture.fromImage(this.sence6s3)
      let sence6p1=new PIXI.Sprite(sence6s3org)

      sence6p1.x=0
      sence6p1.y=0
      sence6p1.width=473
      sence6p1.height=701

      senceCont0.addChild(sence6p1)


      //3
      let senceS=new PIXI.Container()
      senceCont0.addChild(senceS)
      senceS.x=463
      senceS.y=0

      let sence6s5org=PIXI.Texture.fromImage(this.sence6s5)
      let sence6p3=new PIXI.Sprite(sence6s5org)

      sence6p3.x=0
      sence6p3.y=0
      sence6p3.width=473
      sence6p3.height=701

      senceS.addChild(sence6p3)

      //信封
      this.sence6mailer=new PIXI.Container()
      senceS.addChild(this.sence6mailer)
      this.sence6mailer.x=181
      this.sence6mailer.y=92

      let sence6s6org=PIXI.Texture.fromImage(this.sence6s6)
      let sence6mail=new PIXI.Sprite(sence6s6org)

      sence6mail.x=0
      sence6mail.y=0
      sence6mail.width=199
      sence6mail.height=143

      this.sence6mailer.addChild(sence6mail)


      let sence6s7org=PIXI.Texture.fromImage(this.sence6s7)
      let shanPointer=new PIXI.Sprite(sence6s7org)

      shanPointer.x=100
      shanPointer.y=74
      shanPointer.anchor.x=0.5
      shanPointer.anchor.y=0.5
      shanPointer.width=82
      shanPointer.height=82

      this.sence6mailer.addChild(shanPointer)

      /*let handtiporg=PIXI.Texture.fromImage(this.handtip)
      let handtipw=new PIXI.Sprite(handtiporg)

      handtipw.x=120
      handtipw.y=124
      handtipw.anchor.x=0.5
      handtipw.anchor.y=0.5
      handtipw.width=60
      handtipw.height=70

      this.sence6mailer.addChild(handtipw)*/

      


      //左手
      let sence6s2org=PIXI.Texture.fromImage(this.sence6s2)
      let sence6lefthand=new PIXI.Sprite(sence6s2org)

      sence6lefthand.x=0
      sence6lefthand.y=566
      sence6lefthand.width=375
      sence6lefthand.height=815

      this.sence6.addChild(sence6lefthand)


      //右手
      let sence6s1org=PIXI.Texture.fromImage(this.sence6s1)
      this.sence6hand=new PIXI.Sprite(sence6s1org)

      this.sence6hand.x=750
      this.sence6hand.y=405
      this.sence6hand.width=458
      this.sence6hand.height=552

      this.sence6.addChild(this.sence6hand)

      //文字
      let senceCont=new PIXI.Container()
      senceCont.x=345
      senceCont.y=1136
      this.sence6.addChild(senceCont)


      let sence6txt1org=PIXI.Texture.fromImage(this.sence6txt1)
      this.sence6t1=new PIXI.Sprite(sence6txt1org)
      this.sence6t1.x=0
      this.sence6t1.y=0
      this.sence6t1.width=378
      this.sence6t1.height=45
      this.sence6t1.alpha=0
      senceCont.addChild(this.sence6t1)


      let sence6txt2org=PIXI.Texture.fromImage(this.sence6txt2)
      this.sence6t2=new PIXI.Sprite(sence6txt2org)
      this.sence6t2.x=0
      this.sence6t2.y=45
      this.sence6t2.width=378
      this.sence6t2.height=49
      this.sence6t2.alpha=0
      senceCont.addChild(this.sence6t2)


      let sence6txt3org=PIXI.Texture.fromImage(this.sence6txt3)
      this.sence6t3=new PIXI.Sprite(sence6txt3org)
      this.sence6t3.x=0
      this.sence6t3.y=94
      this.sence6t3.width=378
      this.sence6t3.height=43
      this.sence6t3.alpha=0
      senceCont.addChild(this.sence6t3)
    },


    sence6StageMotion(){
      

      //手机
      //背景口播
      let koubodata={
        name:'007'
      }

      this.$emit('gokoubo',koubodata) 

      let _this=this

      let sence6Children=this.sence6.children
      
      //手机屏幕
      let mobilescreen=sence6Children[1].children

      setTimeout(()=>{
        //您有一条新的消息
        mobilescreen[1].visible=false
        let data={
          name:'message'
        }

        _this.$emit('gomymusic',data)

        //右手去点击
        TweenMax.to(_this.sence6hand,1,{x:422,y:231,ease:Sine.easeOut,onComplete:()=>{
            let data2={
              name:'msg'
            }

            _this.$emit('gomymusic',data2)
            //右手收回
            TweenMax.to(_this.sence6hand,1,{x:750,y:405,ease:Sine.easeOut})
            //微信内容展示
            TweenMax.to(mobilescreen[2],1,{x:0,ease:Sine.easeOut,onComplete:()=>{
              _this.sence6mailer.interactive=true

              _this.sence6mailer.on('touchend',()=>{
                //执行翻页
                //_this.fanyue('sence6','resultstageMotion')
                this.fanyue2()
              })

              //提示的点一闪一闪
              let diandian=_this.sence6mailer.children
              TweenMax.to(diandian[1].scale,1,{x:0.6,y:0.6,ease:Sine.easeOut,repeat:-1})
              //TweenMax.to(diandian[2].scale,1,{x:0.8,y:0.8,ease:Sine.easeOut,repeat:-1})
            }})
        }})
      },2000)


      //文字
      TweenMax.to(_this.sence6t1,1,{alpha:1,ease:Sine.easeOut,delay:1})
      TweenMax.to(_this.sence6t2,1,{alpha:1,ease:Sine.easeOut,delay:2})
      TweenMax.to(_this.sence6t3,1,{alpha:1,ease:Sine.easeOut,delay:3})
    },

    fanyue2(){
      let appnum=this.appkv.stage.children.length-1
      this.appkv.stage.setChildIndex(this.result,appnum)
      //优化画布
      $('#mypageKV').css({'transform':'translate(0,0px)'})

      this.resultstageMotion()
    },


    resultstage(){
      this.result=new PIXI.Container()
      this.appkv.stage.addChild(this.result)

      //背景
      let bgbox=new PIXI.Container()
      this.result.addChild(bgbox)
      bgbox.x=0
      bgbox.y=0

      let resultbgorg=PIXI.Texture.fromImage(this.resultbg)
      let resultsbgs=new PIXI.Sprite(resultbgorg)

      resultsbgs.x=0
      resultsbgs.y=0
      resultsbgs.width=750
      resultsbgs.height=1380

      bgbox.addChild(resultsbgs)

      //月亮
      let resultmoonorg=PIXI.Texture.fromImage(this.resultmoon)
      let resultmoons=new PIXI.Sprite(resultmoonorg)

      resultmoons.x=553
      resultmoons.y=60
      resultmoons.width=159
      resultmoons.height=170

      bgbox.addChild(resultmoons)

      let resultmoon2org=PIXI.Texture.fromImage(this.resultmoon2)
      let resultmoons2=new PIXI.Sprite(resultmoon2org)

      resultmoons2.x=553
      resultmoons2.y=60
      resultmoons2.width=159
      resultmoons2.height=170

      bgbox.addChild(resultmoons2)

      //星星
      let resultstarsorg=PIXI.Texture.fromImage(this.resultstars)
      let resultstarss=new PIXI.Sprite(resultstarsorg)

      resultstarss.x=14
      resultstarss.y=68
      resultstarss.width=727
      resultstarss.height=418

      bgbox.addChild(resultstarss)

      //烟花
      let yanhuo=new PIXI.Container()
      this.result.addChild(yanhuo)
      yanhuo.x=0
      yanhuo.y=0

      //1
      let yanhuo1=new PIXI.Container()
      yanhuo.addChild(yanhuo1)
      yanhuo1.x=175
      yanhuo1.y=254

      let resulty1org=PIXI.Texture.fromImage(this.resulty1)
      let resulty1s=new PIXI.Sprite(resulty1org)

      resulty1s.x=84/2
      resulty1s.y=100/2
      resulty1s.width=84
      resulty1s.height=100
      resulty1s.anchor.x = 0.5;
      resulty1s.anchor.y = 0.5;
      yanhuo1.addChild(resulty1s)

      //2
      let yanhuo2=new PIXI.Container()
      yanhuo.addChild(yanhuo2)
      yanhuo2.x=356
      yanhuo2.y=373

      let resulty2org=PIXI.Texture.fromImage(this.resulty2)
      let resulty2s=new PIXI.Sprite(resulty2org)

      resulty2s.x=155/2
      resulty2s.y=336/2
      resulty2s.width=155
      resulty2s.height=336
      resulty2s.anchor.x = 0.5;
      resulty2s.anchor.y = 0.5;
      yanhuo2.addChild(resulty2s)

      //3
      let yanhuo3=new PIXI.Container()
      yanhuo.addChild(yanhuo3)
      yanhuo3.x=242
      yanhuo3.y=348

      let resulty3org=PIXI.Texture.fromImage(this.resulty3)
      let resulty3s=new PIXI.Sprite(resulty3org)

      resulty3s.x=114/2
      resulty3s.y=177/2
      resulty3s.width=114
      resulty3s.height=177
      resulty3s.anchor.x = 0.5;
      resulty3s.anchor.y = 0.5;
      yanhuo3.addChild(resulty3s)


      //4
      let yanhuo4=new PIXI.Container()
      yanhuo.addChild(yanhuo4)
      yanhuo4.x=582
      yanhuo4.y=174

      let resulty4org=PIXI.Texture.fromImage(this.resulty4)
      let resulty4s=new PIXI.Sprite(resulty4org)

      resulty4s.x=156/2
      resulty4s.y=159/2
      resulty4s.width=156
      resulty4s.height=159
      resulty4s.anchor.x = 0.5;
      resulty4s.anchor.y = 0.5;
      yanhuo4.addChild(resulty4s)


      //5
      let yanhuo5=new PIXI.Container()
      yanhuo.addChild(yanhuo5)
      yanhuo5.x=0
      yanhuo5.y=20

      let resulty5org=PIXI.Texture.fromImage(this.resulty5)
      let resulty5s=new PIXI.Sprite(resulty5org)

      resulty5s.x=224/2
      resulty5s.y=225/2
      resulty5s.width=224
      resulty5s.height=225
      resulty5s.anchor.x = 0.5;
      resulty5s.anchor.y = 0.5;
      yanhuo5.addChild(resulty5s)

      //6
      let yanhuo6=new PIXI.Container()
      yanhuo.addChild(yanhuo6)
      yanhuo6.x=512
      yanhuo6.y=291

      let resulty6org=PIXI.Texture.fromImage(this.resulty6)
      let resulty6s=new PIXI.Sprite(resulty6org)

      resulty6s.x=235/2
      resulty6s.y=230/2
      resulty6s.width=235
      resulty6s.height=230
      resulty6s.anchor.x = 0.5;
      resulty6s.anchor.y = 0.5;
      yanhuo6.addChild(resulty6s)

      //7
      let yanhuo7=new PIXI.Container()
      yanhuo.addChild(yanhuo7)
      yanhuo7.x=0
      yanhuo7.y=269

      let resulty7org=PIXI.Texture.fromImage(this.resulty7)
      let resulty7s=new PIXI.Sprite(resulty7org)

      resulty7s.x=205/2
      resulty7s.y=249/2
      resulty7s.width=205
      resulty7s.height=249
      resulty7s.anchor.x = 0.5;
      resulty7s.anchor.y = 0.5;
      yanhuo7.addChild(resulty7s)

      //8
      let yanhuo8=new PIXI.Container()
      yanhuo.addChild(yanhuo8)
      yanhuo8.x=248
      yanhuo8.y=0

      let resulty8org=PIXI.Texture.fromImage(this.resulty8)
      let resulty8s=new PIXI.Sprite(resulty8org)

      resulty8s.x=359/2
      resulty8s.y=357/2
      resulty8s.width=359
      resulty8s.height=357
      resulty8s.anchor.x = 0.5;
      resulty8s.anchor.y = 0.5;
      yanhuo8.addChild(resulty8s)


      let resultbg2org=PIXI.Texture.fromImage(this.resultbg2)
      let resultsbgs2=new PIXI.Sprite(resultbg2org)

      resultsbgs2.x=0
      resultsbgs2.y=0
      resultsbgs2.width=750
      resultsbgs2.height=1380

      this.result.addChild(resultsbgs2)



      //元素
      let deng=new PIXI.Container()
      this.result.addChild(deng)
      deng.x=0
      deng.y=995

      let results1org=PIXI.Texture.fromImage(this.results1)
      let results1s=new PIXI.Sprite(results1org)

      results1s.x=0
      results1s.y=101
      results1s.width=601
      results1s.height=52

      deng.addChild(results1s)

      let results2org=PIXI.Texture.fromImage(this.results2)
      let results2s=new PIXI.Sprite(results2org)

      results2s.x=0
      results2s.y=0
      results2s.width=475
      results2s.height=383

      deng.addChild(results2s)


      let results3org=PIXI.Texture.fromImage(this.results3)
      let results3s=new PIXI.Sprite(results3org)

      results3s.x=284
      results3s.y=101
      results3s.width=354
      results3s.height=286

      deng.addChild(results3s)


      //按钮
      let btnbox=new PIXI.Container()
      this.result.addChild(btnbox)
      btnbox.x=0
      btnbox.y=920

      let hh=$(window).height()


      let resultbtn1org=PIXI.Texture.fromImage(this.resultbtn1)
      let resultbtn1s=new PIXI.Sprite(resultbtn1org)
      let fangda=1.4
      resultbtn1s.x=115+210/2-15
      resultbtn1s.y=0+61/2
      resultbtn1s.width=210*fangda
      resultbtn1s.height=61*fangda
      resultbtn1s.anchor.x = 0.5;
      resultbtn1s.anchor.y = 0.5;
      resultbtn1s.interactive=true

      btnbox.addChild(resultbtn1s)
      resultbtn1s.on('touchend',function(){
        window.location.href='https://pro.m.jd.com/mall/active/2YLaALCGaYDKyErZuKAfr8CEhnYu/index.html'
      })


      let resultbtn2org=PIXI.Texture.fromImage(this.resultbtn2)
      let resultbtn2s=new PIXI.Sprite(resultbtn2org)

      resultbtn2s.x=437+215/2+15
      resultbtn2s.y=0+61/2
      resultbtn2s.width=215*fangda
      resultbtn2s.height=61*fangda
      resultbtn2s.anchor.x = 0.5;
      resultbtn2s.anchor.y = 0.5;
      resultbtn2s.interactive=true

      btnbox.addChild(resultbtn2s)
      resultbtn2s.on('touchend',function(){
        $('.sharetip').show()
      })

      $('.sharetip').on('touchend',()=>{
        $('.sharetip').hide()
      })

      //logo
      let resultlogoorg=PIXI.Texture.fromImage(this.resultlogo)
      let resultlogos=new PIXI.Sprite(resultlogoorg)

      resultlogos.x=35
      resultlogos.y=0
      resultlogos.width=175
      resultlogos.height=58

      bgbox.addChild(resultlogos)

      //文字
      this.resulttxtCont=new PIXI.Container()
      this.result.addChild(this.resulttxtCont)
      this.resulttxtCont.x=62
      this.resulttxtCont.y=194

      let resulttxt1org=PIXI.Texture.fromImage(this.resulttxt1)
      let resulttxt1s=new PIXI.Sprite(resulttxt1org)

      resulttxt1s.x=0
      resulttxt1s.y=0
      resulttxt1s.width=564
      resulttxt1s.height=101
      resulttxt1s.alpha=0
      this.resulttxtCont.addChild(resulttxt1s)

      let resulttxt2org=PIXI.Texture.fromImage(this.resulttxt2)
      let resulttxt2s=new PIXI.Sprite(resulttxt2org)

      resulttxt2s.x=109
      resulttxt2s.y=92
      resulttxt2s.width=493
      resulttxt2s.height=92
      resulttxt2s.alpha=0
      this.resulttxtCont.addChild(resulttxt2s)
    },

    resultstageMotion(){
      let _this=this
      
      //烟花声音
      let data={
        name:'yanhua'
      }

      _this.$emit('gomymusic',data)

      let resultchildren=this.result.children

      //月亮&&星星
      let msbox=resultchildren[0].children
      //月亮
      TweenMax.to(msbox[1],2,{alpha:0.5,ease:Sine.easeOut,repeat:-1,repeatDelay:2})
      TweenMax.to(msbox[1],2,{alpha:1,ease:Sine.easeOut,repeat:-1,repeatDelay:2,delay:2})
      //星星
      TweenMax.to(msbox[3],1,{alpha:0.2,ease:Sine.easeOut,repeat:-1,repeatDelay:1})
      TweenMax.to(msbox[3],1,{alpha:1,ease:Sine.easeOut,repeat:-1,repeatDelay:1,delay:1})


      //灯闪
      let dengs=resultchildren[3].children
      TweenMax.to(dengs[0],3,{alpha:0.7,ease:Sine.easeOut,repeat:-1})
      TweenMax.to(dengs[2],3,{alpha:0.7,ease:Sine.easeOut,repeat:-1})

      //烟花
      let yanhubox=resultchildren[1]
      let yanhu=resultchildren[1].children
      

      //1
      let yy1=yanhu[0].children
      yanhu[0].x=175
      yanhu[0].y=1434
      yy1[0].scale.x=0.1
      yy1[0].scale.y=0.1
      TweenMax.to(yanhu[0],1,{x:175,y:254,ease:Sine.easeOut,repeatDelay:2})
      TweenMax.to(yy1[0].scale,2,{x:1,y:1,ease:Expo.easeInOut,repeatDelay:1})

      //2 ************************************
      let yy2=yanhu[1].children
      yanhu[1].x=356+30
      yanhu[1].y=1670
      yy2[0].scale.x=0.1
      yy2[0].scale.y=0.1
      TweenMax.to(yanhu[1],1.5,{x:356,y:373,ease:Sine.easeOut,repeatDelay:1.5})
      TweenMax.to(yy2[0].scale,1.5,{x:1,y:1,ease:Expo.easeInOut,repeatDelay:1.5})

      //3 ************************************
      let yy3=yanhu[2].children
      yanhu[2].x=242
      yanhu[2].y=1511
      yy3[0].scale.x=0.1
      yy3[0].scale.y=0.1
      TweenMax.to(yanhu[2],2,{x:242,y:348,ease:Sine.easeOut,repeatDelay:1})
      TweenMax.to(yy3[0].scale,2,{x:1,y:1,ease:Expo.easeInOut,repeatDelay:1})

      //4
      let yy4=yanhu[3].children
      yanhu[3].x=582
      yanhu[3].y=1493
      yy4[0].scale.x=0.1
      yy4[0].scale.y=0.1
      TweenMax.to(yanhu[3],1,{x:582,y:174,ease:Sine.easeOut,repeatDelay:2})
      TweenMax.to(yy4[0].scale,2,{x:1,y:1,ease:Expo.easeInOut,repeatDelay:1})

      //5
      let yy5=yanhu[4].children
      yanhu[4].x=0
      yanhu[4].y=1559
      yy5[0].scale.x=0.1
      yy5[0].scale.y=0.1
      TweenMax.to(yanhu[4],1,{x:0,y:20,ease:Sine.easeOut,repeatDelay:2})
      TweenMax.to(yy5[0].scale,2,{x:1,y:1,ease:Expo.easeInOut,repeatDelay:1})

      //6
      let yy6=yanhu[5].children
      yanhu[5].x=512
      yanhu[5].y=1564
      yy6[0].scale.x=0.1
      yy6[0].scale.y=0.1
      TweenMax.to(yanhu[5],1,{x:512,y:291,ease:Sine.easeOut,repeatDelay:2})
      TweenMax.to(yy6[0].scale,2,{x:1,y:1,ease:Expo.easeInOut,repeatDelay:1})

      //7 ************************************
      let yy7=yanhu[6].children
      yanhu[6].x=0-30
      yanhu[6].y=1583
      yy7[0].scale.x=0.1
      yy7[0].scale.y=0.1
      TweenMax.to(yanhu[6],1,{x:0,y:269,ease:Sine.easeOut,repeatDelay:2})
      TweenMax.to(yy7[0].scale,1,{x:1,y:1,ease:Expo.easeInOut,repeatDelay:2})

      //8
      let yy8=yanhu[7].children
      yanhu[7].x=248
      yanhu[7].y=1691
      yy8[0].scale.x=0.1
      yy8[0].scale.y=0.1
      TweenMax.to(yanhu[7],1,{x:248,y:0,ease:Sine.easeOut,repeatDelay:2})

      let mybtn=resultchildren[4].children
      TweenMax.to(mybtn[0].scale,1,{x:1.05,y:1.05,ease:Sine.easeOut,repeat:-1})
      TweenMax.to(mybtn[1].scale,1,{x:1.05,y:1.05,ease:Sine.easeOut,repeat:-1})

      TweenMax.to(yy8[0].scale,2,{x:1,y:1,ease:Expo.easeInOut,repeatDelay:1,onComplete:()=>{
        //烟花消失
        TweenMax.to(yanhubox,1,{alpha:0,ease:Sine.easeOut,repeatDelay:1,onComplete:()=>{
          //背景口播
          let koubodata={
            name:'008'
          }

          _this.$emit('gokoubo',koubodata)


          //文字
          let rtxt=_this.resulttxtCont.children
          TweenMax.to(rtxt[0],2,{alpha:1,ease:Sine.easeOut})
          TweenMax.to(rtxt[1],2,{alpha:1,ease:Sine.easeOut,delay:2,onComplete:()=>{
              

          }})
        }})
      }})

    }



  },
  watch:{
    carsubtype(){
      /******* 主舞台 BEGIN *******/ 
      this.mainkvMotion()
      //this.fanyue2()
      /******* 主舞台 END *******/
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .shoushi{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: none;

    .sbox{
      width:27.5625/2rem /* 441/16 */;
      height:3.9375/2rem /* 63/16 */;
      position: absolute;
      left: 50%;
      margin-left: -27.5625/4rem;
      top: 80vh;
      background-image: url(./s1-10.png);
      background-size: 100% 100%;
    }

    .sboxinner{
      width:20.5/2rem /* 328/16 */;
      height: 100%;
      position: relative;
      margin: 0 auto
    }

    .pointer{
      width:3.625/2rem /* 58/16 */;
      height:3.625/2rem /* 58/16 */;
      position: absolute;
      left: 0;
      top: 0;
      background-image: url(./s1-11.png);
      background-size: 100% 100%;
      
    }
    .paction{
      animation: mtip 2s infinite;
    }
    
    
  }
  @keyframes mtip {
    0%{
      left: 16.875/2rem /* 270/16 */;
    }
    100%{
      left: 0;
    }
  }


  .sharetip{
      display: none;
      position: absolute;
      left: 0;
      top: 0;
      background-color: rgba(0,0,0,.8);
      width: 100%;
      height: 100%;
      z-index: 9;

      .stip1{
        background-image: url(./share-tip1.png);
        background-size: 100% 100%;
        width: 19.9375/2rem /* 319/16 */;
        height: 6.0625/2rem /* 97/16 */;
        position: absolute;
        left: 23.4375/2rem /* 375/16 */;
        top: 0;
        animation: mstip1 3s infinite;
        transform-origin: 90% 0;
      }

      .stip2{
        background-image: url(./share-tip2.png);
        background-size: 100% 100%;
        width: 22.9375/2rem /* 367/16 */;
        height: 29.9375/2rem /* 479/16 */;
        position: absolute;
        left: 23.3125/2rem /* 373/16 */;
        top: 6.4375/2rem /* 103/16 */;
        animation: piao 8s infinite;
      }
    }

    @keyframes mstip1 {
      0%{
        transform: rotate(5deg)
      }
      50%{
        transform: rotate(-5deg)
      }
      100%{
        transform: rotate(5deg)
      }
    }

    @keyframes piao {
      0%{
        transform: translate(-200px,300px);
        opacity: 0.2;
      }
      50%{
        opacity: 1;
      }
      100%{
        transform: translate(0,0)
      }
    }
</style>
